module.exports = __webpack_public_path__ + "img/basics.c7914b84.svg";